import { createId } from "../../app/runtimeContext";
import type { CyanPriority, PlanTask } from "./types";

export type TaskPlannerInput = {
  title: string;
  description: string;
  priority: CyanPriority;
  risk: number;
  estimatedEffortHours: number;
  expectedOutcome: string;
  dependencies?: string[];
  subtasks?: Array<Omit<TaskPlannerInput, "subtasks">>;
};

export class TaskPlanner {
  createTask(input: TaskPlannerInput): PlanTask {
    return {
      id: createId("plan_task"),
      title: input.title,
      description: input.description,
      status: "planned",
      priority: input.priority,
      dependencies: input.dependencies ?? [],
      risk: input.risk,
      estimatedEffortHours: input.estimatedEffortHours,
      expectedOutcome: input.expectedOutcome,
      progressPercent: 0,
      subtasks: (input.subtasks ?? []).map((subtask) =>
        this.createTask({ ...subtask, subtasks: [] }),
      ),
    };
  }
}
